<template>
  <div class="oms-tabs-wrap">
    <Tabs :act="curActPage" :panes="panes" @del="onTabDel" @delAll="onTabDelAll" />
  </div>
</template>

<script>
import mainBus from "@/micro/eventBus";
import Tabs from "./children/Tabs.vue";

export default {
  name: "OmsTabs",
  components: { Tabs },
  data() {
    return {};
  },
  watch: {
    "$route.fullPath": {
      handler(newVal, oldVal) {
        // 当上一个路由是 CCRM 嵌入页而新路由不在 /ccrm/ 下时，
        // 说明是嵌入子应用发起的跨应用跳转，MicroBase 会重定向回 /ccrm/embedded/...
        // 跳过此瞬态路由，避免发送错误的 sub-tab 覆盖子应用 keep-alive include
        if (
          typeof oldVal === 'string' && oldVal.startsWith('/ccrm/embedded/') &&
          typeof newVal === 'string' && !newVal.startsWith('/ccrm/')
        ) {
          return;
        }
        this.addRoute();
      },
      immediate: true,
    },
    "panes.length": {
      handler() {
        if (this.panes.length === 0) {
          this.$router.push("/");
        }
      },
    },
  },
  computed: {
    curActPage() {
      return this.$route.fullPath;
    },
    panes() {
      return this.$store.state.tabs.list;
    },
  },
  created() {
    mainBus.$on("route-change", (info) => {
      this.$store.commit("fixTab", info);
    });
    setTimeout(() => {
      mainBus.$emit("sub-tab", JSON.stringify(this.panes));
    }, 500);
  },
  methods: {
    onTabDel(e) {
      this.$store.commit("delTab", e.index);
      if (e.isCur) {
        this.$nextTick(() => {
          if (this.panes.length > 0) {
            const toIndex = e.index - 1 >= 0 ? e.index - 1 : 0;
            this.$router.push(this.panes[toIndex].path);
          }
        });
      }
      mainBus.$emit('sub-tab', JSON.stringify(this.panes));
    },
    addRoute() {
      const { fullPath, meta: { title = "" } = {} } = this.$route;
      // ccrm 子应用有自己的 TagsView，不在主应用标签栏生成标签
      if (fullPath.startsWith("/ccrm/")) {
        return;
      }
      this.$store.commit("addTab", {
        title,
        path: fullPath,
      });
      mainBus.$emit("sub-tab", JSON.stringify(this.panes));
    },
    onTabDelAll() {
      this.$store.commit("delAllTab", this.curActPage);
      mainBus.$emit("sub-tab", JSON.stringify(this.panes));
    },
  },
};
</script>

<style lang="less" scoped>
.oms-tabs-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
